/* eslint-disable no-unused-vars */
/* eslint-disable quote-props */

import SidebarFilters from 'V2/components/SidebarFilters';
import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import useProposalCenterStore from 'store/ProposalCenter/state';
import { Row } from 'xpi-black-ui/Base/Grid';
import Icon from 'xpi-black-ui/Base/Icon';
import Loading from 'xpi-black-ui/Base/Loading';
import Page from 'xpi-black-ui/Base/Page';
import { H1, Text } from 'xpi-black-ui/Base/Typography';
import Wrapper from 'xpi-black-ui/Base/Wrapper';
import Dropdown from 'xpi-black-ui/Common/Dropdown';
import { exportToCSV } from 'xpi-black-ui/Utils/exportExcel';
import { converToNumber } from 'xpi-black-ui/Utils/helpers';
import BlackContainer from '../../../../components/Common/BlackContainer';
import PageView from '../../../../components/Common/PageView';
import useProposalsCenter from '../../../../store/ProposalCenter/queries/useProposalsCenter';
import { NEW_PUSH_URL, OLD_PUSH_URL } from '../../../../utils/api';
import request from '../../../../utils/request';
import waConfig from '../../../../utils/waConfig';
import ModalPush from '../ModalPush';
import ProposalsList from './ProposalsList';
import { DefaultProps, Props } from './shape';
import { Container, Content, Header } from './styles';

const OperationProposalsPage = () => {
  const [filtered, setFiltered] = useState([]);
  const [pushHtml, setPushHtml] = useState('');
  const [filteredArray, setFilteredArray] = useState([]);
  const [formatedFilter, setFormatedFilter] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);
  const [proposalsExcel, setProposalsExcel] = useState([]);
  const { filters, proposals, isLoading, isError, refetch } = useProposalsCenter(filtered);
  const { getCancelProposal } = useProposalCenterStore();

  useEffect(() => {
    const newFilters = { ...filters };

    const temp = filters?.map((filter, index) => {
      const newOptions = filter.options.map((option, optionIndex) => {
        const matchingOptions = filteredArray.find(o => o.options.some(i => i.id === option.id));
        if (matchingOptions) {
          const matchingOptionsSelected = matchingOptions.options.find(
            o => o.id === option.id,
          );

          if (matchingOptionsSelected.isSelected !== option.isSelected) {
            return {
              ...option,
              isSelected: matchingOptionsSelected.isSelected,
            };
          }
        }
        return option;
      });
      return {
        ...filter,
        options: newOptions,
      };
    });
    setFormatedFilter(temp);
  }, [filters]);

  useEffect(() => {
    setLoadingPage(isLoading);
  }, [isLoading]);

  useEffect(() => {
    setLoadingPage(false);
    setProposalsExcel(
      proposals?.map(proposal => ({
        Cliente: proposal.cliente,
        Ação: proposal.ativo,
        'Preço referência': proposal.precoReferencia,
        Estrutura: proposal.estrutura,
        Quantidade: proposal.quantidade,
        Encerramento: proposal.vencimento,
        'Preço final': proposal.precoFinal,
        Comissão: proposal.comissaoNumerico,
        Envio: proposal.dataInclusao,
        Status: proposal.status.name,
      })),
    );
  }, [proposals]);

  const onFilter = () => {
    setLoadingPage(true);
    refetch();
  };

  const onCancelProposal = (proposalId) => {
    setLoadingPage(true);
    getCancelProposal(proposalId)
      .then((response) => {
        toastr.success(
          'Cancelado com sucesso',
          'Cancelamento da proposta foi efetuado com sucesso',
        );
        refetch();
        setLoadingPage(false);
      })
      .catch((e) => {
        toastr.error('Tenta novamente', 'Falha ao carregar as informações');
        refetch();
      });
  };

  const getParamFiltered = (value) => {
    setFilteredArray(value);

    const params = [];
    value.forEach((filter) => {
      filter.options.forEach((option) => {
        if (option.isSelected) {
          params.push(`Filtros.${filter.name}=${option.id}`);
        }
      });

      if (filter.type === 'date' && filter.extraParam) {
        params.push(
          filter.extraParam
            .map(param => `Filtros.${param.name}=${param.id}`)
            .join('&'),
        );
      }
    });

    setFiltered(params.length > 0 ? `?${params.join('&')}` : []);
  };

  const onViewPush = (proposal) => {
    setLoadingPage(true);
    request(
      `${NEW_PUSH_URL}?OperacaoId=${proposal.operacaoSugeridaId}&Quantidade=${converToNumber(proposal.quantidade)}&OrdemId=${proposal.codigoOrdem}`,
    ).then((response) => {
      if (!response.error) {
        setPushHtml({
          response,
          operationId: proposal.operacaoSugeridaId,
        });
      }
      setLoadingPage(false);
    });
  };

  const renderNoContent = () => <Text>Nenhuma proposta foi encontrada.</Text>;

  const renderContent = () => (
    <Content>
      <Header justifyContent="space-between" align="baseline">
        <Text bigger>Lista de Clientes</Text>
        <Icon type="update" title="Atualizar" onClick={() => onFilter()} />
      </Header>
      <ProposalsList
        proposals={proposals}
        onViewPush={onViewPush}
        cancelProposal={onCancelProposal}
      />
    </Content>
  );

  const renderLoading = () => <Loading text="Carregando..." fixed />;

  return (
    <Container>
      <PageView page={waConfig.pageview.proposalCenter} />
      <BlackContainer>
        <Page className="page">
          <SidebarFilters
            filters={formatedFilter}
            onFilter={getParamFiltered}
            filterNames={[
              { name: 'ativos', size: 150 },
              { name: 'clientes', size: 175 },
              { name: 'estruturas', size: 150 },
              { name: 'listaDataContratacao', size: 95 },
              { name: 'status', size: 125 },
              { name: 'vencimentos', size: 125 },
            ]}
          />
          <Wrapper spaceTop innerWrapper>
            <Row border justifyContent="space-between" align="baseline">
              <H1 noMargin>Central de Propostas - Operações</H1>
              {proposals?.length > 0 && (
                <Dropdown
                  title="Exportar"
                  dataWa={waConfig.event.proposalCenter.export}
                  items={[
                    {
                      text: 'Excel',
                      link: () => {
                        exportToCSV(proposalsExcel, 'propostas');
                      },
                    },
                  ]}
                />
              )}
            </Row>
            <>
              {isLoading || (loadingPage && renderLoading())}
              {!isError && proposals?.length > 0 && renderContent()}
              {proposals?.length === 0 && renderNoContent()}
              {pushHtml && (
                <ModalPush
                  open={pushHtml}
                  pushHtml={pushHtml}
                  onClose={() => {
                    setPushHtml(null);
                  }}
                />
              )}
            </>
          </Wrapper>
        </Page>
      </BlackContainer>
    </Container>
  );
};

OperationProposalsPage.defaultProps = DefaultProps;
OperationProposalsPage.propTypes = Props;

export default OperationProposalsPage;
